import WizardStep from "./WizardStep";

export default class ImportPaidFeaturesStep extends WizardStep {
  type = WizardStep.TYPE_UPLOAD;

  name = 'Paid Features Report v1.1';
  title = Lang.get('admin.revenue.features.import');
  subtitle = Lang.get('admin.revenue.features.whatIsImport');

  getDownloadUrl() {
    const contentOwner = this.revenueUpdate.contentOwner;
    return `https://studio.youtube.com/owner/${contentOwner}/reports/financial?o=${contentOwner}`;
  }

  getHelpText() {
    return [
      'Go to YouTube creator studio.',
      'Click reports.',
      'Choose <em>Paid Features</em> in the reports menu.',
      'Select monthly.',
      `Click download <em>${this.name}</em> for date <em>${this.getTargetHtml()}</em>`,
      `Import downloaded file below.`,
    ];
  }
}
